<template>
  <div>
    <v-container>
      <v-form v-model="isValid" ref="formRef">
        <v-row>
          <v-col xs12 sm6 md5>
            <v-col xs12 sm12 md12>
              <v-text-field
                label="Base Url"
                v-model="sms.baseUrl"
                :disabled="!onEdit"
                required
                :rules="[v => !!v || 'This field is required']"
              ></v-text-field>
            </v-col>
            <v-col xs12 sm12 md12>
              <v-text-field
                label="Sender ID"
                v-model="sms.senderID"
                :disabled="!onEdit"
              ></v-text-field>
            </v-col>
            <v-col xs12 sm12 md12>
              <v-text-field
                label="API Key"
                v-model="sms.apIkey"
                :disabled="!onEdit"
                required
                :rules="[v => !!v || 'This field is required']"
              ></v-text-field>
            </v-col>
            <v-col xs12 sm12 md12>
              <v-text-field
                label="Client Id"
                v-model="sms.clientId"
                :disabled="!onEdit"
              ></v-text-field>
            </v-col>
            <v-col xs12 sm12 md12>
              <v-checkbox
                label="Active"
                v-model="sms.isActive"
                :disabled="!onEdit"
              ></v-checkbox>
            </v-col>
            <v-col xs12 sm12 md12>
              <v-btn text outlined @click="onEdit = true">Edit</v-btn> &nbsp;
              <v-btn
                text
                outlined
                :loading="isSaving"
                @click="save"
                :disabled="!onEdit"
                >Save</v-btn
              >&nbsp;
              <v-btn text outlined @click="onEdit = false" :disabled="!onEdit"
                >cancel</v-btn
              >
            </v-col>

            <v-col xs12 sm12 md12 v-if="onEdit">
              <v-text-field
                label="Contact #"
                v-model="contactNum"
                :disabled="!onEdit"
                hint="639XXXXXXXXX"
                persistent-hint
              ></v-text-field>
            </v-col>

            <v-col xs12 sm12 md12 v-if="onEdit">
              <v-btn
                flat
                outline
                @click="test"
                :disabled="!onEdit"
                :loading="isTesting"
                >Test</v-btn
              >
            </v-col>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </div>
</template>
<script>
import isEmpty from "lodash/isEmpty";
const API_ENDPOINT = "/api/smsConfig";
export default {
  data: () => ({
    isValid: false,
    sms: {},
    isSaving: false,
    onEdit: false,
    isTesting: false,
    contactNum: null
  }),
  methods: {
    save() {
      if (!this.$refs.formRef.validate()) return;
      this.isSaving = true;
      this.$axios
        .post(`${API_ENDPOINT}/sms-busybee`, this.sms)
        .then(({ data }) => {
          this.$toast.success(data.message);
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    getSMS() {
      this.$axios
        .get(`${API_ENDPOINT}/sms-busybee`)
        .then(({ data }) => {
          if (!isEmpty(data)) {
            this.sms = data;
          }
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    test() {
      if (!isEmpty(this.contactNum)) {
        this.isTesting = true;
        this.$axios
          .post(
            `${API_ENDPOINT}/sms-busybee/test?contactNum=${this.contactNum}`
          )
          .then(({ data }) => {
            this.$toast.success(data.message);
          })
          .catch(({ response }) => {
            this.$toast.error(response.data.message);
          })
          .finally(() => {
            this.isTesting = false;
          });
      } else {
        this.toast.error("Contact Number is required.");
      }
    }
  },
  created() {
    this.getSMS();
  }
};
</script>
